import { api } from "../../api";
import { handleResponse, RequestOptions } from "../types";
import { getCookie } from "../../helpers/utils";
import { cookieToken } from "../../constants";


const getList = (data: any)  => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.list;

  const payload = {
    ...data,
    authenticity_token: authenticity_token,
  }

  return fetch(`${endpoint}`, {...RequestOptions('POST', JSON.stringify(payload))})
    .then(handleResponse)
    .then(
      data => {
        return data;
      }
    )
    .catch((error) => {
      return error
    });
};

const getFilterCreator = (data: any) => {
  const authenticity_token = getCookie(cookieToken);

  const endpoint = api.admin.wlCreator.filterCreators;

  const payload = {
    ...data,
    authenticity_token,
  };

  return fetch(`${endpoint}`, { ...RequestOptions('POST', JSON.stringify(payload)) })
    .then(handleResponse)
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return error;
    });
};

export const wlCreatorService = {
	getList,
  getFilterCreator,
};
